<template>
  <div>
    <!-- Hero Section -->
    <section class="py-20 bg-gradient-dark">
      <div class="container mx-auto px-6 text-center">
        <div class="flex items-center justify-center mb-6">
          <router-link to="/services" class="text-gold-400 hover:text-gold-300 transition-colors duration-300 mr-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </router-link>
          <h1 class="text-4xl md:text-6xl font-display font-bold text-gold-400">
            SURGICAL GUIDES
          </h1>
        </div>
        <p class="text-xl text-gold-300 max-w-3xl mx-auto">
          Digitally planned precise implant positioning for improved surgical outcomes.
        </p>
      </div>
    </section>

    <!-- Products -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <div class="max-w-4xl mx-auto">
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <!-- Digital Design -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">Digital Design</h3>
                <p class="text-gray-300">Accurate, digitally planned implant positioning with precision planning.</p>
              </div>
              
              <!-- CBCT Integration -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">CBCT + Scan Integration</h3>
                <p class="text-gray-300">Designed using CBCT + intraoral scan integration for comprehensive planning.</p>
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <!-- Precision & Safety -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">Precision & Safety</h3>
                <p class="text-gray-300">Improved precision, safety, and predictability during surgery with guided placement.</p>
              </div>
              
              <!-- Customized Planning -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">Customized Planning</h3>
                <p class="text-gray-300">Customized for each patient's anatomy and treatment plan for optimal results.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Back to Services -->
    <section class="py-20">
      <div class="container mx-auto px-6 text-center">
        <router-link to="/services" class="btn-secondary inline-flex items-center">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to All Services
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SurgicalGuides'
}
</script>